import React from "react";
import PropTypes from "prop-types";
import Button from "components/Button";
import Alert from "components/Alert";
import deleteCMBSBorrowerService from "services/cmbs/deleteCMBSBorrowerService";
import useAsync from "hooks/useAsync";
import useToast from "hooks/useToast";

function DeleteCMBSBorrower({ borrower, onDelete }) {
  const { showSuccess, showError } = useToast();
  const [alertVisible, setAlertVisible] = React.useState(false);

  const [fetch, pending] = useAsync({
    promiseFn: deleteCMBSBorrowerService,
    onData: () => {
      showSuccess("Borrower deleted successfully.");
      onDelete();
    },
    onError: (error) => {
      console.error(error);
      showError("Error deleting Borrower");
    },
  });

  return (
    <>
      <Button
        size="sm"
        icon="trash"
        intent="danger"
        onClick={() => setAlertVisible(true)}
        loading={pending}
      />
      <Alert
        isOpen={alertVisible}
        onConfirm={() =>
          fetch({ dealCode: borrower.deal_code, id: borrower.id })
        }
        intent="danger"
        icon="trash"
        onCancel={() => setAlertVisible(false)}
      >
        Are you sure you want to delete the Borrower{" "}
        <b>{borrower.entity_id.long_name}</b>?
      </Alert>
    </>
  );
}

DeleteCMBSBorrower.propTypes = {
  borrower: PropTypes.object,
  onDelete: PropTypes.func.isRequired,
};

DeleteCMBSBorrower.defaultProps = {
  borrower: {},
};

export default DeleteCMBSBorrower;
